export const hasDatalayer = (w)=>w['dataLayer'] != undefined;
export const pushDataLayer = (d)=>{
    if (hasDatalayer(window)) {
        window.dataLayer.push(d);
    } else {
        console.log("No dataLayer variable present to push ", d);
    }
};
